// src/App.js
import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import AppRoutes from './AppRoutes';
import AppTheme from './shared-theme/AppTheme';
function App() {
  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <AppRoutes />
    </AppTheme>
  );
}

export default App;
